import domReady from '@wordpress/dom-ready';

domReady( function() {
    const blocks = document.querySelectorAll('div.wp-block-washu-photo-spotlight-extended');
    var query = window.matchMedia("(min-width: 656px)") // $break-sm

    if ( query.matches ) {
        for (let index = 0; index < blocks.length; index++) {
            const block = blocks[index];
            var left = block.querySelector('.left');
            var right = block.querySelector('.right');
    
            getHeight(left, right);
        }
    
    }

    function getHeight(left, right) {
        const leftHeight = left.offsetHeight;
        const rightHeight = right.offsetHeight;
        const diff = rightHeight - leftHeight;

        // if text box is less than 32px bigger than the image, let's add a class to force some extra space on the image
        if ( diff > 0 && diff < 64) {
            left.classList.add('imgSpace');
        }
    }

    require("waypoints/lib/noframework.waypoints.js");
    const elems = document.querySelectorAll(
		".wp-block-washu-photo-spotlight"
	);
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    elems.forEach((el) => {
        if (!mediaQuery || !mediaQuery.matches) {
            el.classList.add("animate--hide");

            new Waypoint({
                element: el,
                handler: function () {
                    el.classList.remove("animate--hide");
                    el.classList.add("fadeInUp");
                    this.destroy();
                },
                offset: "90%",
            });
        }
	});
});